import { API } from 'aws-amplify'

export const loadSurveys = () => API.get('SurveyAPI', '/surveys')
